import { getService } from '../utils';

export async function requestCancelDownload(buildId?: string): Promise<void> {
  const dataService = getService('softwareUpdate')();

  await dataService.create({
    cancelDownloadRequested: true,
    targetBuildID: buildId,
  });
}
